import React from "react";
import PropTypes from "prop-types";

const Spinner = () => (
    <div className="lm-loading">
        <div className="lds-ring">
            <div />
            <div />
            <div />
            <div />
        </div>
    </div>
);

const Loading = ({ enabled, children, classes, ...props }) => (
    <div className={classes}>
        {children}
        {enabled && <Spinner {...props} />}
    </div>
);

Loading.propTypes = {
    enabled: PropTypes.bool,
    classes: PropTypes.string,
};

export default Loading;
